import { UpperCasePipe } from '../../filters/upper-case.pipe';
import { LowerCasePipe } from '../../filters/lower-case.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { InputAutocompleteComponent } from '../../components/input-autocomplete/input-autocomplete.component';
import { InputTabsComponent } from '../../components/input-tabs/input-tabs.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import BusinessRestServices from '../../services/business-rest.service';
import Config from '../../utils/config.service';
import Session from '../../utils/session.service';
import UserService from '../../services/user.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularFilterHelperService from '../../services/angular-filter-helper.service';
import AngularRoutingHelperService from '../../services/angular-routing-helper.service';
import RoutingService from '../../services/routing.service';
import moment from 'moment';

@Component({
	standalone: true,
	selector: 'booking-prescription',
	templateUrl: './booking-prescription.component.html',
	imports: [
		CommonModule, UpperCasePipe, LowerCasePipe, TranslatePipe,
		LoaderOverlayComponent, InputAutocompleteComponent,
		InputTabsComponent, FormsModule
	]
})
export default class PrescriptionComponent implements OnInit, OnDestroy {
	private restService: RestService = inject(RestService);
	private businessRestServices: BusinessRestServices = inject(BusinessRestServices);
	private config: Config = inject(Config);
	private session: Session = inject(Session);
	private userService: UserService = inject(UserService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularFilterHelperService: AngularFilterHelperService = inject(AngularFilterHelperService);
	private angularRoutingHelperService: AngularRoutingHelperService = inject(AngularRoutingHelperService);
	private routingService: RoutingService = inject(RoutingService);

	vm: any = undefined;
	watcher: any = undefined;

	constructor() {
		this.vm = this;
	}

	ngOnInit() {
		this.vm.isPreVisit = false;
		this.vm.thirdPartyRenewal = undefined;

		this.routingService.validateAccess('booking').then(() => {
			var params: any = this.angularRoutingHelperService.getQueryParams() || {};
			if (params['type'] === 'pre-visit') {
				this.vm.isAvailable = true;
				this.onResolve();
			} else {
				this.businessRestServices.getOnDemandSettings({}, (settings) => {
					var service: any = settings.filter((item) => {
						return item.subcategory === 'GENERAL_MEDICAL_PRACTICE' && !item.furtherSubcategory;
					})[0];
					var gmtHours: any = moment().utc().hours();
					var isAvailable: boolean = !service.onHold && (!service.startTimeInHours || gmtHours >= service.startTimeInHours)
						&& (!service.endTimeInHours || gmtHours < service.endTimeInHours);

					this.vm.isAvailable = isAvailable;

					this.onResolve();
				});
			}

		});
	}
	
	ngOnDestroy() {
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}

	onResolve() {
		this.handleViewInit();

		var currentDrugIngredient = {};
		var currentDrug = {};
		this.watcher = this.angularHelperService.createInterval(() => {
			if (this.vm.formData
				&& this.vm.formData.drugIngredient
				&& !this.angularHelperService.isEqual(this.vm.formData.drugIngredient, currentDrugIngredient)) {
				this.handleIngredientChange(this.vm.formData.drugIngredient, currentDrugIngredient);
				currentDrugIngredient = Object.assign({}, this.vm.formData.drugIngredient);
			}
			
			if (this.vm.formData
				&& this.vm.formData.drug
				&& !this.angularHelperService.isEqual(this.vm.formData.drug, currentDrug)) {
				this.handleDrugChange(this.vm.formData.drug, currentDrug);
				currentDrug = Object.assign({}, this.vm.formData.drug);
			}
		}, 500);

		this.vm.params = this.angularRoutingHelperService.getQueryParams() || {};
		if (this.vm.params['type'] === 'pre-visit') {
			this.vm.isPreVisit = true;
		}
		if (this.vm.params['pNr']) {
			this.vm.prescriptionNumber = this.vm.params['pNr'];
			this.vm.ehifPrescription = this.userService.getEhifPrescription(this.vm.params['pNr']);
			if (this.vm.ehifPrescription) {				
				this.vm.formData.drugIngredient = this.vm.ehifPrescription.drugIngredient;
				this.handleIngredientChange(this.vm.formData.drugIngredient, undefined);
			}
		}
		if (this.vm.prescriptionNumber) {
			this.vm.drugSearchRequired = false;
		} else {
			this.vm.drugSearchRequired = true;
		}

		// Assign values to scope
		this.vm.getExistingPrescriptionDetails = this.getExistingPrescriptionDetails;
		this.vm.handleIngredientSearch = this.handleIngredientSearch;
		this.vm.handleDrugSearch = this.handleDrugSearch;
		this.vm.handleFormSubmit = this.handleFormSubmit;
		this.vm.handleRedirectHome = this.handleRedirectHome;
		this.vm.sendReminder = this.sendReminder;
	}

	getExistingPrescriptionDetails() {
		var fullDetails: any = this.vm.prescriptionNumber;
		if (this.vm.drugName) {
			fullDetails += ", " + this.vm.drugName;
		}
		if (this.vm.ingredientName) {
			fullDetails += ", " + this.vm.ingredientName;
		}
		return fullDetails;
	}

	handleViewInit() {
		var rawData: any = window.sessionStorage.getItem(this.config.getBookingConfig().Instant.STORAGE_KEY);
		var booking: any = rawData ? JSON.parse(rawData) : {};
		this.vm.thirdPartyRenewal = window.sessionStorage.getItem("THIRD_PARTY_RENEWAL");

		this.vm.formData = booking.prescriptionRequest || {};

		if (!this.angularHelperService.equals(this.vm.formData, {})) {
			this.vm.hasSideEffects = this.vm.formData.sideEffects ? 'YES' : 'NO';
			this.vm.isProlongedRequestAllowed = this.vm.formData.isProlongedRequestAllowed ? 'YES' : 'NO';
		}

		this.vm.token = this.angularRoutingHelperService.getQueryParam('token')
			|| (booking.prescriptionRequest && booking.prescriptionRequest.prescription && booking.prescriptionRequest.prescription.token);

		if (this.vm.token) {
			var benu: any = "benu";
			window.sessionStorage.setItem("THIRD_PARTY_RENEWAL", benu);
			this.vm.thirdPartyRenewal = benu;

			this.vm.prescriptionNumber = this.angularRoutingHelperService.getQueryParam('prescriptionNumber')
				|| booking.prescriptionRequest.prescription.prescriptionNumber;
			if (this.vm.prescriptionNumber) {
				this.vm.drugSearchRequired = false;
			} else {
				this.vm.drugSearchRequired = true;
			}
			if (this.angularRoutingHelperService.getQueryParam('drugName')) {
				this.vm.drugName = this.angularRoutingHelperService.getQueryParam('drugName')
					|| booking.prescriptionRequest.prescription.drugName;
			}
			if (this.angularRoutingHelperService.getQueryParam('ingredientName')) {
				this.vm.ingredientName = this.angularRoutingHelperService.getQueryParam('ingredientName')
					|| booking.prescriptionRequest.prescription.ingredientName;
			}
		}

		this.vm.descriptionMaxLength = 1024;
		this.vm.disabledDisclaimerTypes = ['ANTIBACTERIAL', 'ANTIVIRAL', 'PSYCHOTROPIC', 'DISABLED'];
		this.vm.confirmDisclaimerTypes = ['STATINS', 'HYPERTENSION', 'NEUROLOGICAL', 'ERECTILE', 'CONTRACEPTIVES'];

		this.vm.labels = {
			usage: this.angularFilterHelperService.translate('Booking.Prescription.Usage_Label'),
			effect: this.angularFilterHelperService.translate('Booking.Prescription.Effect_Label'),
			expiry: this.angularFilterHelperService.translate('Booking.Prescription.Expiry_Label'),
			reason: this.angularFilterHelperService.translate('Booking.Prescription.Reason'),
			sideEffectsToggle: this.angularFilterHelperService.translate('Booking.Prescription.Side_Effects_Label'),
			prolongedRequestAllowedToggle: this.angularFilterHelperService.translate('Booking.Prescription.Prolonged_Request_Allowed')
		};
		this.vm.disclaimers = {
			'DISABLED': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Disabled'),
			'ANTIBACTERIAL': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Antibacterial'),
			'ANTIFUNGAL': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Antifungal'),
			'ANTIVIRAL': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Antiviral'),
			'PSYCHOTROPIC': this.angularFilterHelperService.translate('Booking.Prescription.Disclaimer_Psychotropic'),
		};

		this.vm.usages = [{
			id: 'UP_TO_7_DAYS',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Usages.UP_TO_7_DAYS'),
		}, {
			id: 'UP_TO_14_DAYS',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Usages.UP_TO_14_DAYS'),
		}, {
			id: 'UP_TO_30_DAYS',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Usages.UP_TO_30_DAYS'),
		}, {
			id: 'UP_TO_180_DAYS',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Usages.UP_TO_180_DAYS'),
		}, {
			id: 'UP_TO_INFINITY',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Usages.UP_TO_INFINITY'),
		}];

		this.vm.effects = [{
			id: 'GOOD',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Effects.GOOD'),
		}, {
			id: 'UNDETERMINED',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Effects.UNDETERMINED'),
		}, {
			id: 'INEFFECTIVE',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Effects.INEFFECTIVE'),
		}];

		this.vm.expiries = [{
			id: 'DAYS_14',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Expiries.DAYS_14'),
		}, {
			id: 'MONTHS_1',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Expiries.MONTHS_1'),
		}, {
			id: 'MONTHS_2',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Expiries.MONTHS_2'),
		}, {
			id: 'MONTHS_3',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Expiries.MONTHS_3'),
		}];

		this.vm.reasons = [{
			id: 'EXPIRED',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Reasons.EXPIRED'),
		}, {
			id: 'LOST',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Reasons.LOST'),
		}, {
			id: 'FINISHED',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Reasons.FINISHED'),
		}, {
			id: 'OTHER',
			name: this.angularFilterHelperService.translate('Booking.Prescription.Reasons.OTHER'),
		}];

		this.vm.sideEffectsToggle = [{
			id: 'YES',
			name: this.angularFilterHelperService.translate('Common.Yes'),
		}, {
			id: 'NO',
			name: this.angularFilterHelperService.translate('Common.No'),
		}];

		this.vm.prolongedRequestAllowedToggle = [{
			id: 'YES',
			name: this.angularFilterHelperService.translate('Common.Yes'),
		}, {
			id: 'NO',
			name: this.angularFilterHelperService.translate('Common.No'),
		}];
	}

	handleIngredientChange(nv, ov) {
		var newIngredient: any = nv || {};
		var newIngredientId: any = newIngredient.id;
		var oldIngredient: any = ov || {};
		var oldIngredientId: any = oldIngredient.id;
		if (newIngredientId === oldIngredientId) return;

		this.handleDisclaimerUpdate(newIngredient);
		if (!this.vm.ehifPrescription && this.vm.formData.drugIngredient) {
			this.vm.formData.drugIngredient['availability'] = this.handleDrugAvailability(newIngredient);
			this.vm.invalidDrug = !this.vm.formData.drugIngredient['availability'];
		}

		this.vm.drugOpts = {};
		if (newIngredientId) {
			this.vm.drugOpts.ingredientId = newIngredientId;

			this.restService.savePrescriptionStats({ drugIngredientId: newIngredientId }).catch(console.log);
		}

		this.vm.formData.drug = undefined;
	}

	handleDrugChange(nv, ov) {
		var newDrug: any = nv || {};
		var newDrugId: any = newDrug.id;
		var oldDrug: any = ov || {};
		var oldDrugId: any = oldDrug.id;
		if (newDrugId === oldDrugId) return;

		this.handleDisclaimerUpdate(newDrug);
		if (!this.vm.ehifPrescription && this.vm.formData.drug) {
			this.vm.formData.drug['availability'] = this.handleDrugAvailability(newDrug);
			this.vm.invalidDrug = !this.vm.formData.drug['availability'];
		}

		if (newDrugId) {
			this.restService.savePrescriptionStats({ drugId: newDrugId }).catch(console.log);
		}
	}

	handleDrugAvailability(drug): boolean {
		if (!drug || !drug.id) return true;
		return !drug.disclaimerType || this.vm.disabledDisclaimerTypes.indexOf(drug.disclaimerType) === -1;
	}

	handleDisclaimerUpdate(medication) {
		if (!medication) return;
		if (medication.type || !medication.enabled) {
			medication.disclaimerType = medication.type || 'DISABLED';
			medication.disclaimer = this.vm.disclaimers[medication.disclaimerType];
			medication.disclaimerConfirm = this.vm.confirmDisclaimerTypes.indexOf(medication.disclaimerType) !== -1;
			medication.disclaimerUrl = medication.disclaimerConfirm
				? this.config.getBaseUrl() + '/disclaimers/' + medication.disclaimerType.toLowerCase()
				: undefined;
		}
	}

	handleIngredientSearch = (searchData) => {
		var deferred: any = this.angularHelperService.getDeferredPromise();

		var namePart = searchData.namePart;
		this.restService.getPrescriptionIngredients({ namePart: namePart })
			.then((ingredients) => {
				ingredients.forEach((ingredient) => {
					ingredient.isAvailable = !!(ingredient.enabled && this.vm.disabledDisclaimerTypes.indexOf(ingredient.type) === -1);
				});
				deferred.resolve(ingredients);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});

		return deferred.promise;
	}

	handleDrugSearch = (searchData) => {
		var deferred: any = this.angularHelperService.getDeferredPromise();

		var namePart = searchData.namePart;
		var ingredientId = searchData.ingredientId;
		var params = { namePart: namePart };
		if (ingredientId) {
			params['ingredientId'] = ingredientId;
		}
		this.restService.getPrescriptionDrugs(params)
			.then((drugs) => {
				drugs.forEach((drug) => {
					if (drug.amount) drug.name = drug.name + ' ' + drug.amount;
					drug.isAvailable = !!(drug.enabled && this.vm.disabledDisclaimerTypes.indexOf(drug.type) === -1);
				});
				deferred.resolve(drugs);
			})
			.catch((err) => {
				console.error(err);
				deferred.reject(err);
			});

		return deferred.promise;
	}

	handleFormSubmit(mainForm: any) {
		this.vm.submitted = true;
		this.validateData(mainForm);
		if (this.vm.isProcessing || this.validateData(mainForm)) {
			return;
		}
		this.vm.isProcessing = true;

		var booking: any = {};
		booking.subcategory = 'GENERAL_MEDICAL_PRACTICE';
		booking.type = 'PRESCRIPTION_REQUEST';
		booking.origin = this.session.getSession().user.origin;
		if (this.vm.hasSideEffects !== 'YES') delete this.vm.formData.sideEffects;
		booking.prescriptionRequest = this.vm.formData;
		if (this.vm.isProlongedRequestAllowed == 'YES') {
			booking.prolongedRequestAllowed = true;
		} else {
			booking.prolongedRequestAllowed = false;
		}
		if (this.vm.token) {
			// prescription info coming from Benu
			booking.prescriptionRequest.prescription = {};
			booking.prescriptionRequest.prescription.prescriptionNumber = this.vm.prescriptionNumber;
			booking.prescriptionRequest.prescription.drugName = this.vm.drugName;
			booking.prescriptionRequest.prescription.ingredientName = this.vm.ingredientName;
			booking.prescriptionRequest.prescription.token = this.vm.token;
		} else if (this.vm.prescriptionNumber) {
			// prescription info coming from X-road for paid service
			booking.prescriptionRequest.prescription = {};
			booking.prescriptionRequest.prescription.prescriptionNumber = this.vm.prescriptionNumber;
			if (this.vm.ehifPrescription) {
				booking.prescriptionRequest.prescription.ingredientName = this.vm.ehifPrescription.atcName;
			}
		}
		if (this.vm.params['type'] === 'pre-visit') {
			booking.ehifPrescription = this.vm.ehifPrescription;
		}

		window.sessionStorage.setItem(this.config.getBookingConfig().Instant.STORAGE_KEY, JSON.stringify(booking));

		this.angularRoutingHelperService.clearQueryParamsDirty();
		if (this.vm.params['type'] === 'pre-visit') {
			this.angularRoutingHelperService.setPath('/pre-visit/prescription/checkout');
		} else {
			this.angularRoutingHelperService.setPath('/booking/prescription/checkout');
		}
	}
	
	validateData(mainForm: any) {
		var hasErrors = false;
		if (this.vm.drugSearchRequired) {
			if (!this.vm.formData.drugIngredient && !this.vm.formData.drug) {				
				this.vm.invalidDrug = true;
				hasErrors = true;
			} else if (!(this.vm.formData?.drugIngredient?.availability || this.vm.formData?.drug?.availability)) {
				this.vm.invalidDrug = true;
				hasErrors = true;
			}
		} else {
			this.vm.invalidDrug = false;
		}
		if (mainForm.invalid) {
			hasErrors = true;
		}
		if (!this.vm.formData.prescriptionUsage) {
			hasErrors = true;
		}
		if (!this.vm.formData.prescriptionEffect) {
			hasErrors = true;
		}
		if (!this.vm.formData.prescriptionExpiry) {
			hasErrors = true;
		}
		if (!this.vm.formData.prescriptionRequestReason) {
			hasErrors = true;
		}
		if (!this.vm.hasSideEffects) {
			hasErrors = true;
		}
		if (!this.vm.isPreVisit && !this.vm.isProlongedRequestAllowed) {
			hasErrors = true;
		}
		
		this.vm.formInvalid = hasErrors;
		return hasErrors;
	}

	handleRedirectHome() {
		this.angularRoutingHelperService.clearQueryParamsDirty()
		this.angularRoutingHelperService.goHomeAndKeepHistory(this.session.getSession() ? this.session.getSession().user : null);
	}

	sendReminder() {
		if (this.vm.isProcessing || this.vm.reminderSent) {
			return;
		}

		this.vm.isProcessing = true;

		this.restService.saveReminderTrigger({ accessToken: this.vm.token, platform: 'BROWSER' })
			.then(() => {
				this.vm.isProcessing = false;
				this.vm.reminderSent = true;
			})
			.catch((e) => {
				console.error(e);
			});
	}

}